import type { DashboardItem } from '@shared/types';

interface Props { item: DashboardItem }

const COPY: Partial<Record<DashboardItem['status'], string>> = {
  drafting: 'Claude is writing the first draft. Updates will appear here when the preview is ready.',
  building: 'Building or updating the preview. This usually takes a minute or two.',
  publishing: 'Publishing — the article will be live as soon as checks pass.',
  failed: 'Something went wrong. Open the issue or PR on GitHub to triage.',
};

export function DraftingEmpty({ item }: Props) {
  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <div className="max-w-md text-center space-y-3">
        <h2 className="text-lg font-medium">{item.title}</h2>
        <p className="text-muted-foreground">{COPY[item.status] ?? ''}</p>
        <a className="text-sm underline" href={item.htmlUrl} target="_blank" rel="noreferrer">
          Open on GitHub
        </a>
        {item.pr?.failedRunUrl && (
          <div>
            <a
              className="text-sm underline text-destructive"
              href={item.pr.failedRunUrl}
              target="_blank"
              rel="noreferrer"
            >
              View failing workflow run
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
